import VueSlickCarousel from 'vue-slick-carousel';

export default {
    name: 'homeFeaturedProducts',
    components: {
        VueSlickCarousel
    },
	props: [
		'shopDomain',
		'productBlocks'
    ],
    computed: {
        hasSwatches: function(prod){
            if(prod.length){
                return true;
            }
        }
    },
	data() {
		return {
            settings:{
                'lazyLoad': 'ondemand',
                'arrows': true,
                'slidesToShow':3,
                'infinite':true,
                'draggable':true,
                'swipeToSlide':true,
                'touchMove':true,
                'responsive': [
                    {
                        'breakpoint': 992,
                        'settings': {
                            'slidesToShow': 2
                        }
                    },
                    {
                        'breakpoint': 768,
                        'settings': {
                            'slidesToShow': 1,
                            'arrows': false,
                            'dots': true
                        }
                    }
                ]
            },
            imgSrc: null, 
            featuredImages: []
		};
	},
	methods: {
        //Set Image Sizes
        imgSizes(){
            var str = "Visit Microsoft!";
            var res = str.replace("Microsoft", "W3Schools");
        },
        // If the color name matches the swatch name
        availableSwatch(color, product){
            // if the product has variants
            if (product.variants){
                // for each variant
                for ( let i = 0; i < product.variants.length; i++ ) {
                    // if the variant title includes the selected color
                    if ( product.variants[i].title.includes(color[0]) ) {
                        // if the variant is available
                        if (product.variants[i].available && product.variants[i].featured_image ){
                            // set the swatch image
                            //console.log(product.variants[i].featured_image);
							//console.log('yo');
                            color[2] = product.variants[i].featured_image.src;
                            return true;
                        }
                    }
                }
            }
        },
        // switch images
        switchImages(img, product){
            this.imgSrc = img;
            product.imgMd = img;
            //console.log(this);
            //this.imgSrc = img;
        },
        // set the title width
        titleWidth(){
            var title = document.getElementById('secTitle');
            var arrowPrev = document.querySelector('.ctpx-product-row #homeFeaturedProducts .slick-prev');
            var arrowNext = document.querySelector('.ctpx-product-row #homeFeaturedProducts .slick-next');
            var titWidth = title.offsetWidth;
            arrowPrev.style.left = titWidth + 'px'; 
            arrowNext.style.left = titWidth + 'px'; 
            //arrows.classList.add('fart');
            //console.log(titWidth);
        },
        // if tag exists
        tagExists(needle, haystack){
            var length = haystack.length;
            for(var i = 0; i < length; i++) {
                if(haystack[i] == needle) return true;
            }
            return false;
        },        
        // format price
		formatPrice(price) {
            if( window.location.href.includes('eu.cotopaxi.com') ){
                return '€' + `${price / 100}` + ' incl. VAT, excl. shipping';
            } else {
                return '$' + `${price / 100}`;
            }
        }
    },
	mounted() {
        this.titleWidth();
    }
};